import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import type { ExpiredInformerItemFindInterface } from '@zaoblako/shared/modules/notification/dtos/informer/expired.informer.item.find.dto';
import { ExpiredInformerItemTypeEnum } from '@zaoblako/shared/modules/notification/enums/expired.informer.item.type.enum';
import { ExpiredInformerService } from '@zaoblako/web/core/services/notification/expired-informer.service';
import { NoDataSize } from '@zaoblako/web/shared/components/no-data/constants/no-data-types.enum';
import { NoDataComponent } from '@zaoblako/web/shared/components/no-data/no-data.component';
import { StatusLabelComponent } from '@zaoblako/web/shared/components/status-label/status-label.component';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { OrderByPipe } from '@zaoblako/web/shared/pipes/order-by.pipe';
import { ButtonComponent } from '@zaoblako/web/shared/dumbs/button/button.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TooltipModule } from 'primeng/tooltip';

export interface IExpiredTasksByType {
  title: string;
  tasks: ExpiredInformerItemFindInterface[];
}

@Component({
  standalone: true,
  selector: 'crm-notification-expired-list',
  templateUrl: './notification-expired-list.component.html',
  imports: [
    CommonModule,
    OverlayPanelModule,
    ButtonComponent,
    RouterModule,
    ProgressSpinnerModule,
    OrderByPipe,
    StatusLabelComponent,
    TooltipModule,
    NoDataComponent,
    SpinnerComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationExpiredListComponent {
  public loading = false;
  public paginationLoading = false;
  public expiredTasksByType: IExpiredTasksByType[];

  public countItems: number;
  public NoDataSize: NoDataSize.M;

  public informerOpen = false;

  public constructor(
    private readonly expiredInformerService: ExpiredInformerService,
    private readonly cdRef: ChangeDetectorRef
  ) {}

  public onInformerShow(): void {
    this.informerOpen = true;
    this.loadNotifications();
    this.cdRef.markForCheck();
  }

  public onInformerHide(): void {
    this.informerOpen = false;
    this.cdRef.markForCheck();
  }

  public loadNotifications() {
    this.loading = true;
    this.cdRef.markForCheck();

    this.expiredInformerService.getExpiredObjects().subscribe({
      next: (expired) => {
        this.expiredTasksByType = [
          { title: 'Задачи', tasks: expired.filter((obj) => obj.type === ExpiredInformerItemTypeEnum.PROJECT) },
          {
            title: 'Заявки HelpDesk',
            tasks: expired.filter((obj) => obj.type === ExpiredInformerItemTypeEnum.HD_TASK)
          },
          {
            title: 'Заявки на платеж',
            tasks: expired.filter((obj) => obj.type === ExpiredInformerItemTypeEnum.BRS_TASK)
          }
        ];
        this.countItems = expired.length ?? 0;
        this.loading = false;
        this.paginationLoading = false;
        this.cdRef.markForCheck();
      },
      error: () => {
        this.loading = false;
        this.cdRef.markForCheck();
      }
    });
  }

  public getEntityTypeLink(expiredTask: ExpiredInformerItemFindInterface) {
    switch (expiredTask.type) {
      case ExpiredInformerItemTypeEnum.PROJECT: {
        return `/project/card/${expiredTask.id}`;
      }
      case ExpiredInformerItemTypeEnum.HD_TASK: {
        return `/helpdesk/task/card/${expiredTask.id}`;
      }
      case ExpiredInformerItemTypeEnum.BRS_TASK: {
        return `/payments/task/card/${expiredTask.id}`;
      }
      default: {
        return null;
      }
    }
  }
}
